import type { FaireProductEntity } from "../../entity_types/product";

export const p_8vk8g4f3t9: FaireProductEntity = {
  token: "p_8vk8g4f3t9",
  type: "product",
  name: "VHS Match Box Set- Horror",
  brandToken: "b_b703e67f",
  brandName: "A Shop of Things",
  imageUrl:
    "https://cdn.faire.com/fastly/4e3334cbf91fc7b62babf87cca257d2de80147585ff5451586205a950e948611.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8bcc2bff5a203d536d5b96f3bcfadef220bdf255296a8a003f758fca003d244d.jpeg",
    "https://cdn.faire.com/fastly/e3d58d07e7c71ef168cec725ff2bad0d41464fabd6bfed9e6d83170ea66d91c3.jpeg",
    "https://cdn.faire.com/fastly/32fc313d94a97ccdcad530793a4be20a0b6715762092bfe82adaf4c6c9571f53.jpeg",
    "https://cdn.faire.com/fastly/afe0373396cdaae3bc204d48487eef92068dc96f8044cc95b78a5e378a30d264.jpeg",
    "https://cdn.faire.com/fastly/1f48661a6585bb2f66436bfe0bc6d9ce564170e3f6b19df5a9034825b7f73a8e.jpeg",
    "https://cdn.faire.com/fastly/e19ce91cb2cbd4239268a01f6ae60c2977a06467fbfaa3e988bb489c2f46b8e0.jpeg",
    "https://cdn.faire.com/fastly/7494513d5767f40adec5eac66a1d65c5a6379ee4407d2393c747f547f37b8da4.jpeg",
    "https://cdn.faire.com/fastly/f937174bb08d0054e725337d1c7ed967045ff2494e835a4a6b26fc4c92070dc6.jpeg",
    "https://cdn.faire.com/fastly/bfb606c0e73d350b57a3cc686373d7d5169b04b912223eb295fd4a38277bad31.jpeg",
    "https://cdn.faire.com/fastly/a566caf05f9b2c3f6e8b0fd7d3ac79164fb27f934e1316ba6927d95eb4b386aa.jpeg",
    "https://cdn.faire.com/fastly/71017ddd17b4a5f38748b3b66a93a317e6c5c1400a9733c27f148fed2fc5b22d.jpeg",
    "https://cdn.faire.com/fastly/94e564a1d22257d63abf6d4eaa77345cc50fa6fa904349c5f2187a2c9282c90c.jpeg",
    "https://cdn.faire.com/fastly/282692c023716531af9e41e943dd0972c93bd06d85f35e0199dfdc378a671c58.jpeg",
    "https://cdn.faire.com/fastly/2989b350b9536df85d7c12c24a573ea91c81143a4ac8979a806dcdafe00aa97d.jpeg",
    "https://cdn.faire.com/fastly/b9a1c23f95f8dc966018344f7679a65bd2d23c93f69696c65d4723164fd0a359.jpeg",
    "https://cdn.faire.com/fastly/cf9475f836260a7c25179bee93dc0d97e74876ca3843485a21a8e3e175366d53.jpeg",
    "https://cdn.faire.com/fastly/718ac9a2265d56e6dd020ae801fc1116ffb4dd3583d5718ed516d61b1b482b9a.jpeg",
  ],
  priceDollars: 8,
  description:
    'Our newest match set, featuring your favorite horror classics!! \n\n6 unique matchbooks designed to look like classic horror VHS tapes. Each matchbook sits inside a decorative box that looks like a retro TV! Designs include Halloween, Elvira: Mistress of the Dark, Scream, Killer Klowns from Outer Space, The Craft, and American Psycho.\n\nComes in a 2.25" x 1.5" x 2.5" box and each individual matchbox measures 1.5" x 2.25". Includes red tipped black matches.\n\nPlease be careful when using this product and keep away from children! We can not be held liable for any misuse or accidents that occur when using this product.\n\nLighters/matches can NOT be shipped internationally.\n\nThis design is the sole property of A Shop of Things and cannot be reproduced or copied for any reason without permission beforehand. ©\n',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:29.303Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
